import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { REFILLABLE_TYPES, REPLENISH_LINKS, dictionary } from "../constants";
import { AnimalSoc } from "../types";
export * from "./fub";
export var isElkPlanBMainBannerHideURLEnabled = function isElkPlanBMainBannerHideURLEnabled() {
  var _window, _window$abTestChoices;
  return !!((_window = window) !== null && _window !== void 0 && (_window$abTestChoices = _window.abTestChoices) !== null && _window$abTestChoices !== void 0 && _window$abTestChoices.elkPlanBmainBannerHideURLEnabled);
};
export var getNextBillingDate = function getNextBillingDate(billingDate) {
  var withYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var withTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!billingDate) {
    return null;
  }
  var initialDate = new Date(billingDate);
  var currentYear = new Date().getFullYear();
  var billingDateYear = initialDate.getFullYear();
  var billingDateHours = initialDate.getHours();
  var billingDateHMinutes = "".concat(initialDate.getMinutes());
  var billingTime = "".concat(billingDateHours, ":").concat(billingDateHMinutes.padStart(2, '0'));
  var nextBillingDate = "".concat(initialDate.getDate(), " ").concat(dictionary.monthRULocale[initialDate.getMonth()]);
  if (withTime) {
    nextBillingDate += " ".concat(billingTime);
  }
  if (withYear && currentYear !== billingDateYear) {
    nextBillingDate += " ".concat(billingDateYear);
  }
  return nextBillingDate;
};
export var getBalanceDateText = function getBalanceDateText() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isFullText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var lastDate = getNextBillingDate(date, false, true);
  if (!lastDate) {
    return '';
  }
  var message = "\u043D\u0430 ".concat(lastDate, ", \u041C\u0421\u041A");
  return isFullText ? "\u0411\u0430\u043B\u0430\u043D\u0441 ".concat(message) : message;
};
export var getBalanceTypeAndBalanceName = function getBalanceTypeAndBalanceName(balance) {
  return "".concat(balance === null || balance === void 0 ? void 0 : balance.balanceType, "-").concat(balance === null || balance === void 0 ? void 0 : balance.balanceName);
};
export var getExtendedBalanceList = function getExtendedBalanceList(list) {
  return list === null || list === void 0 ? void 0 : list.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      refillable: !!REFILLABLE_TYPES[item === null || item === void 0 ? void 0 : item.balanceType],
      key: getBalanceTypeAndBalanceName(item)
    });
  });
};
export var getReplenishLink = function getReplenishLink(replenishButtonType, href, isSvyazZ) {
  var link = '';
  if (replenishButtonType) {
    link = REPLENISH_LINKS[replenishButtonType] || REPLENISH_LINKS.default;
  }
  if ((replenishButtonType === 'TariffPage' || !replenishButtonType) && href) {
    link = href;
  }
  if (isSvyazZ && replenishButtonType === 'MobileProfilePage') {
    link += '?buyPackagesPopupOpen';
  }
  return link;
};
export var getAccumulatorFill = function getAccumulatorFill(_ref) {
  var isUnlimited = _ref.isUnlimited,
    rest = _ref.rest,
    size = _ref.size;
  if (isUnlimited || !size || rest > size) {
    return 1;
  }
  return Number(rest) / Number(size);
};
export var getUpperName = function getUpperName(animalSoc) {
  switch (animalSoc) {
    case AnimalSoc.POWER1:
    case AnimalSoc.POWER01:
    case AnimalSoc.POWER10:
      return 'Тапа';
    case AnimalSoc.POWER2:
    case AnimalSoc.POWER02:
    case AnimalSoc.POWER20:
      return 'Пинг';
    case AnimalSoc.POWER3:
    case AnimalSoc.POWER03:
    case AnimalSoc.POWER30:
    case AnimalSoc.POWER3A:
      return 'Юнг';
    case AnimalSoc.POWER4:
    case AnimalSoc.POWER04:
    case AnimalSoc.POWER40:
      return 'Базя';
    case AnimalSoc.POWER5:
    case AnimalSoc.POWER05:
    case AnimalSoc.POWER50:
      return 'Пуш';
    default:
      return '';
  }
};
export var composeAccumulator = function composeAccumulator(_ref2) {
  var iconSrc = _ref2.iconSrc,
    value = _ref2.value,
    unit = _ref2.unit;
  return value && unit && {
    iconSrc: iconSrc,
    value: value,
    unit: unit
  };
};